/**
 * @file job.reducer.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jan 31, 2026 14:29
 */
import * as Actions from 'src/store/actions/job.actions';

const initialState = {
    jobs: {
        jobs: [],
        deleteIds: [],
    },
};

const jobReducer = (state = initialState, action) => {
    switch (action.type) {

        // jobSearch - initialQuery
        // -------------------------------------------------------------------
        case Actions.JOB_SEARCH_INITIAL_QUERY_REQUEST:
            return {
                ...state,
                jobs: [],
                dataLoaded: false,
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.JOB_SEARCH_INITIAL_QUERY_SUCCESS:
            return {
                ...state,
                jobs: action.payload.jobs,
                dataLoaded: true,
                serverErrorExists: action.payload.serverErrorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.JOB_SEARCH_INITIAL_QUERY_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        // jobSearch.jobSearch.delete
        // -------------------------------------------------------------------
        case Actions.JOB_SEARCH_DELETE_REQUEST:
            return {
                ...state,
                deleteIds: [],
                serverErrorExists: false,
                serverMessage: '',
                dataLoaded: false,
            };

        case Actions.JOB_SEARCH_DELETE_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                jobs: action.payload.jobs,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.JOB_SEARCH_DELETE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        //*************************/    
        default: {
            return state;
        }
    }
};

export default jobReducer;
